function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import Assert from '../util/Assert';
var SegmentPointComparator = /*#__PURE__*/function () {
  function SegmentPointComparator() {
    _classCallCheck(this, SegmentPointComparator);
    SegmentPointComparator.constructor_.apply(this, arguments);
  }
  return _createClass(SegmentPointComparator, [{
    key: "getClass",
    value: function getClass() {
      return SegmentPointComparator;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }], [{
    key: "relativeSign",
    value: function relativeSign(x0, x1) {
      if (x0 < x1) return -1;
      if (x0 > x1) return 1;
      return 0;
    }
  }, {
    key: "compare",
    value: function compare(octant, p0, p1) {
      if (p0.equals2D(p1)) return 0;
      var xSign = SegmentPointComparator.relativeSign(p0.x, p1.x);
      var ySign = SegmentPointComparator.relativeSign(p0.y, p1.y);
      switch (octant) {
        case 0:
          return SegmentPointComparator.compareValue(xSign, ySign);
        case 1:
          return SegmentPointComparator.compareValue(ySign, xSign);
        case 2:
          return SegmentPointComparator.compareValue(ySign, -xSign);
        case 3:
          return SegmentPointComparator.compareValue(-xSign, ySign);
        case 4:
          return SegmentPointComparator.compareValue(-xSign, -ySign);
        case 5:
          return SegmentPointComparator.compareValue(-ySign, -xSign);
        case 6:
          return SegmentPointComparator.compareValue(-ySign, xSign);
        case 7:
          return SegmentPointComparator.compareValue(xSign, -ySign);
      }
      Assert.shouldNeverReachHere('invalid octant value');
      return 0;
    }
  }, {
    key: "compareValue",
    value: function compareValue(compareSign0, compareSign1) {
      if (compareSign0 < 0) return -1;
      if (compareSign0 > 0) return 1;
      if (compareSign1 < 0) return -1;
      if (compareSign1 > 0) return 1;
      return 0;
    }
  }]);
}();
export { SegmentPointComparator as default };
SegmentPointComparator.constructor_ = function () {};